import { Input, Directive } from '@angular/core';
import { RichTextModel } from '~contentful/models/core/rich-text.model';
import { Model } from '~contentful/models/model';

@Directive()
export class ContentfulComponent<T extends Model | RichTextModel = Model> {
  @Input()
  public readonly model: T;
}
